export enum VisitType {
  HealthPlan = 'Health Plan',
  ModernHealth = 'Modern Health',
}
